import { FormSectionHeader } from "@/components"
import { Card, CardContent } from "@/components/ui"
import { cn } from "@/lib/utils"
import { Bell, MoveRight } from "lucide-react"

const ImportantAlerts = ({alertCards}: {alertCards: any}) => {
  return (
    <Card className="shadow-none">
      <CardContent>
        <FormSectionHeader className="text-[18px] font-[500] flex flex-row items-center gap-2">
          <Bell className="h-6 w-6 text-amber-500" /> Important Alerts
        </FormSectionHeader>
        
        <div className="grid grid-cols-1 gap-3">
          {alertCards?.map((data: any) => (
            <div
              className="flex min-h-[86px] cursor-pointer flex-row items-center gap-4 rounded-lg border border-amber-100 bg-amber-50 p-4"
              key={data?.title}
              onClick={data?.onClick}
            >
              <div
                className={cn(
                  "flex h-10 w-10 shrink-0 items-center justify-center rounded-full",
                  data?.iconClassName
                )}
              >
                <data.icon className="h-6 w-6" />
              </div>
              <div className="flex min-w-0 flex-1 flex-col">
                <span className="text-[15px] font-semibold text-gray-900">
                  {data?.title}
                </span>
                <span className="line-clamp-2 text-[12px] text-gray-700">
                  {data?.subTitle}
                </span>
              </div>
              {data?.onClick ? <MoveRight className="h-5 w-5" /> : <></>}
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  )
}

export default ImportantAlerts;